<div class="d-inline-block">
  <div class="btn btn-outline-default main-button"
       (mouseenter)="openDropDown()"
       (mouseleave)="closeDropDown()">
    {{"QUICK_LINKS.QUICK_LINKS" | translate}}
    <div class="custom-dropdown" *ngIf="dropdownOpen">
      <ng-container *ngIf="linksList?.length; else emptyLinks">
        <ng-container *ngFor="let quickLink of (linksList | rmsSortBy: 'order': 'ASC')">
          <button class="dropdown-item" (click)="openLink(quickLink)" [hidden]="quickLink.hidden">
            <span class="rounded-circle mr-2">{{quickLink.label.substr(0, 1)}}</span>
            {{quickLink.label}}
          </button>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #emptyLinks>
  <span class="dropdown-item">{{"GENERICS.NONE" | translate}}</span>
</ng-template>
